import { request } from '../store/actions/auth-actions'
import http from '../api/http-util'

const makeCall = (apiRequest, token) => {
  const { url, method, body, timeout, ...options } = apiRequest

  switch (method.toUpperCase()) {
    case 'POST':
      return http.post(token, url, body, timeout, options)
    case 'PUT':
      return http.put(token, url, body, timeout, options)
    case 'DELETE':
      return http.delete(token, url, body)
    case 'GET':
    default:
      return http.get(token, url, timeout, options)
  }
}

export const moduleFetch =
  (moduleBase, url, options = {}) =>
  dispatch => {
    const { method = 'GET', body, ...otherOptions } = options

    return dispatch(
      request(makeCall, {
        url: moduleBase + url,
        method,
        body,
        ...otherOptions,
      }),
    )
  }
